document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-topbar-slider]');
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('[data-topbar-slide]');
    if (slides.length <= 1) return;

    let current = 0;
    slides[0].classList.add('is-active');

    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 3000);
  });
});